<template>
  <div>
    <div class="general-data">
      <el-row>
        <el-col class="general-header">
          <h1>Detalle de compra</h1>
          <div class="icons-data">
            <router-link
              :to="{name: 'purchases'}">
              <i class="icon-return-icon"/>
            </router-link>
          </div>
        </el-col>
      </el-row>
      <br>
      <div class="image-event">
        <el-row
          :gutter="20"
          class="data-event">
          <el-col
            :span="3"
            class="icon-event">
            <img
              width="54"
              height="54"
              src="/static/images/arts-icon.svg"
              alt="">
          </el-col>
          <el-col
            :span="20"
            class="name-event">
            <h1>Cirque Du Soileil: Totem</h1>
          </el-col>
          <el-col
            :span="24"
            :offset="3">TAGS
          </el-col>
        </el-row>
      </div>
      <div class="pay-method">
        <el-row>
          <el-col
            :xs="24"
            :sm="12"
            :md="9"
            :lg="9"
            :xl="9"
            class="col-pay">
            <span>Fecha de pago</span><br>
            <span>00 de Septiembre de 2018, 12:00 hrs.</span>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="4"
            :lg="4"
            :xl="4"
            class="col-pay">
            <span>Monto</span><br>
            <span>$200,000.00</span>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="7"
            :lg="7"
            :xl="7"
            class="col-pay">
            <span>Método</span><br>
            <span>Paypal</span>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="4"
            :lg="4"
            :xl="4"
            class="status">
            <i class="icon-check-icon"/>
            <span>Pagado</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="invoice">
      <i class="icon-info-icon"/>
      <span>Los eventos sólo pueden ser facturados durante el mes que se realizó la compra. <b>Quedan 10 días</b></span>
      <div class="btn-invoice">
        <el-button>Facturar</el-button>
      </div>
    </div>
    <div class="data-event-and-user">
      <el-row>
        <el-col class="general-header">
          <h1>Datos del evento</h1>
        </el-col>
        <el-col
          :span="14"
          class="col-data">
          <span>Evento</span><br>
          <span>Cirque Du Soleil: Totem</span>
        </el-col>
        <el-col
          :span="5"
          class="col-data">
          <span>Fecha</span> <br>
          <span>24 de Septiembre del 2018</span>
        </el-col>
        <el-col
          :span="5"
          class="col-data">
          <span>Hora</span> <br>
          <span>16:30 hrs.</span>
        </el-col>
        <el-col
          :span="14"
          class="col-data">
          <span>Foro</span> <br>
          <span>Auditorio Josefa Ortiz de Dominguez</span>
        </el-col>
        <el-col
          :span="5"
          class="col-data">
          <span>Ciudad</span> <br>
          <span>Querétaro</span>
        </el-col>
        <el-col
          :span="5"
          class="col-data">
          <span>Estado</span> <br>
          <span>Querétaro</span>
        </el-col>
      </el-row>
      <br><br><br>
      <el-row>
        <el-col class="general-header">
          <h1>Desglose de la compra</h1>
        </el-col>
      </el-row>
      <mt-detail-purchases/>
    </div>
  </div>
</template>

<script>
import mtDetailPurchases from '../../components/_shared/mt-details-purchases'
export default {
  name: 'DetailsPurchases',
  components: {
    mtDetailPurchases
  }
}
</script>

<style lang="scss" scoped>

  .details-container {
    background-color: white;
    padding: 25px 30px 25px 30px !important;
  }

  .general-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E3E6EA;
    padding-bottom: 15px;
    h1 {
      margin: 0;
      @include font-primary(14px, semibold)
    }
    .icons-data {
      color: black;
      cursor: pointer;
    }
  }

  a {
    text-decoration: none;
    margin-left: 30px;
  }

  .image-event {
    height: 300px;
    background-image: url("/static/images/event-arts-full.jpg");
    background-size: cover;
    position: relative;
    .data-event {
      position: absolute;
      bottom: 40px;
      right: 0;
      left: 0;
      margin: 0 auto;
      width: 100%;
      color: white;
      .icon-event {
        text-align: center;
      }
      .name-event {
        h1 {
          @include font-primary(36px, light);
          color: white;
          margin: 0;
        }
      }
    }
  }

  .pay-method {
    margin-top: 40px;
    .el-row{
      display: flex;
      align-items: center;
    }
    .col-pay{
      span{
        &:not(:last-child){
          color: $carbon;
          @include font-primary(12px, semibold)
        }
      }
    }
    .status{
      i{
        color: $available;
      }
      span{
        @include font-primary(14px, light)
      }

    }
  }

  .invoice{
    margin: 10px 0 10px 0;
    background-color: white;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 2px;
    span{
      width: 100%;
    }
    .btn-invoice{
      text-align: right;
      button{
        background: #fff;
        border: 1px solid $available;
        color: $available;
        height: 30px;
        padding: 0 10px 0 10px;
        @include font-primary(12px, semibold);
        margin-right: 10px;
      }
    }
    i{
      font-size: 16px;
      color: $available;
      margin: 0 10px 0 10px;
    }
  }

  .data-event-and-user{
    background-color: white;
    padding: 25px 30px 25px 30px !important;
    border-radius: 2px;
    .col-data{
      margin-top: 30px;
      span{
        &:first-child{
          @include font-primary(12px, semibold);
          color: $carbon;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user-profile/details-purchases.vue